function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Xpandy = e() : t.Xpandy = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 71);
  }([function (t, e, n) {
    var r = n(29)("wks"),
        i = n(17),
        o = n(2).Symbol,
        u = "function" == typeof o;
    (t.exports = function (t) {
      return r[t] || (r[t] = u && o[t] || (u ? o : i)("Symbol." + t));
    }).store = r;
  }, function (t, e) {
    var n = t.exports = {
      version: "2.5.7"
    };
    "number" == typeof __e && (__e = n);
  }, function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (t, e, n) {
    var r = n(10),
        i = n(18);
    t.exports = n(7) ? function (t, e, n) {
      return r.f(t, e, i(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e, n) {
    var r = n(2),
        i = n(1),
        o = n(3),
        u = n(33),
        c = n(16),
        a = function a(t, e, n) {
      var s,
          f,
          p,
          l,
          d = t & a.F,
          v = t & a.G,
          y = t & a.S,
          m = t & a.P,
          g = t & a.B,
          h = v ? r : y ? r[e] || (r[e] = {}) : (r[e] || {}).prototype,
          w = v ? i : i[e] || (i[e] = {}),
          x = w.prototype || (w.prototype = {});

      for (s in v && (n = e), n) {
        p = ((f = !d && h && void 0 !== h[s]) ? h : n)[s], l = g && f ? c(p, r) : m && "function" == typeof p ? c(Function.call, p) : p, h && u(h, s, p, t & a.U), w[s] != p && o(w, s, l), m && x[s] != p && (x[s] = p);
      }
    };

    r.core = i, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
  }, function (t, e, n) {
    var r = n(20);

    t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e) {
    var n = {}.hasOwnProperty;

    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    t.exports = !n(19)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    var r = n(8);

    t.exports = function (t) {
      if (!r(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(9),
        i = n(66),
        o = n(65),
        u = Object.defineProperty;
    e.f = n(7) ? Object.defineProperty : function (t, e, n) {
      if (r(t), e = o(e, !0), r(n), i) try {
        return u(t, e, n);
      } catch (t) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e, n) {
    var r = n(29)("keys"),
        i = n(17);

    t.exports = function (t) {
      return r[t] || (r[t] = i(t));
    };
  }, function (t, e, n) {
    var r = n(21),
        i = Math.min;

    t.exports = function (t) {
      return t > 0 ? i(r(t), 9007199254740991) : 0;
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e, n) {
    var r = n(13);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == r(t) ? t.split("") : Object(t);
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, n) {
    var r = n(64);

    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;

      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };

        case 3:
          return function (n, r, i) {
            return t.call(e, n, r, i);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    var n = 0,
        r = Math.random();

    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e) {
    var n = Math.ceil,
        r = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = arguments;

    e.debounce = function (t, e, n) {
      var i = void 0;
      return function () {
        clearTimeout(i), i = setTimeout(function () {
          i = null, n || t.apply(void 0, r);
        }, e), n && !i && t.apply(void 0, r);
      };
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e["default"] = function () {
      var t = [];
      return {
        getState: function getState(e) {
          return t.find(function (t) {
            return t.container === e;
          });
        },
        stateExists: function stateExists(e) {
          return t.some(function (t) {
            return t.container === e;
          });
        },
        register: function register(e) {
          var n = {
            items: [],
            isAnimating: !1,
            container: e,
            activeItems: [],
            _preview: "",
            _previewElements: []
          };
          return t.push(n), n;
        }
      };
    }, t.exports = e["default"];
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e["default"] = function (t) {
      var e = {
        container: null,
        items: null,
        autoCloseOnOpen: !0,
        equalHeights: !1,
        arrow: !0,
        arrowPosition: "right",
        previewTemplate: function previewTemplate(t) {
          return '\n        <div class="Xpandy-wrapper">\n            ' + (t.arrow ? '<div class="Xpandy-arrow"></div>' : "") + '\n            <div class="Xpandy-container">\n                <div class="Xpandy-body">\n                    <div class="Xpandy-close--wrapper">\n                        <span class="Xpandy-close"></span>\n                    </div>\n                    <div class="Xpandy-base"></div>\n                </div>\n            </div>\n        </div>\n        ';
        },
        callbacks: {
          onInit: function onInit() {},
          onOpen: function onOpen(t, e) {},
          onClose: function onClose(t, e) {},
          onUpdate: function onUpdate(t, e) {}
        }
      },
          n = [];
      return {
        getConfig: function getConfig(t) {
          return n.find(function (e) {
            return e.container === t;
          });
        },
        register: function register(r) {
          var i = Object.assign(e, t);
          return i.container = r, n.push(i), i;
        }
      };
    }, t.exports = e["default"];
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = u(n(24)),
        i = u(n(23)),
        o = n(22);

    function u(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }

    e["default"] = function (t, e) {
      var n = "string" == typeof t ? document.querySelectorAll(t) : t;
      if (!n.length) return !1;

      var u = (0, r["default"])(e),
          c = (0, i["default"])(),
          a = function a(t) {
        var e = t.element,
            n = t.item,
            r = u.getConfig(e),
            i = c.getState(e);
        if (!i.activeItems.length) return f({
          element: e,
          item: n
        });
        if (i.activeItems.includes(n)) return s({
          element: e,
          item: n
        });
        var o = i.activeItems.find(function (t) {
          return t.offsetTop === n.offsetTop;
        });
        return o ? p({
          element: e,
          item: n,
          itemOnSameRow: o
        }) : (r.autoCloseOnOpen && s({
          element: e
        }, !1), f({
          element: e,
          item: n
        }));
      },
          s = function s(t) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            n = t.element,
            r = t.item,
            i = u.getConfig(n),
            o = c.getState(n);
        return o.isAnimating || !o.activeItems.length ? o : (o.isAnimating = e, (r ? [r] : o.activeItems).forEach(function (t) {
          var e = o._previewElements.find(function (e) {
            return e.parentItem.offsetTop === t.offsetTop;
          });

          i.arrow && e.preview.querySelector(".Xpandy-arrow").classList.remove("Xpandy-arrow--isActive"), e.preview.classList.remove("Xpandy-preview--isOpening"), e.preview.classList.remove("Xpandy-preview--isUpdating"), e.preview.classList.add("Xpandy-preview--isClosing");
          var n = e.parentItem.querySelector(".Xpandy-thumbnail"),
              r = parseInt(getComputedStyle(n)["margin-top"]) + parseInt(getComputedStyle(n)["margin-bottom"]),
              u = n.getBoundingClientRect().height + r;
          e.parentItem.style.height = u + "px", e.preview.style.height = "0px", t.classList.remove("Xpandy-item--isActive"), e.preview.addEventListener("transitionend", function n() {
            o.container.classList.remove("Xpandy--isExpanded"), e.preview.removeEventListener("transitionend", n, !1), o.isAnimating = !1, e.preview.remove(), i.callbacks.onClose(t, o);
          }, !1);
        }), o.activeItems = r ? o.activeItems.filter(function (t) {
          return t !== r;
        }) : [], o._previewElements = r ? o._previewElements.filter(function (t) {
          return t.parentItem.offsetTop !== r.offsetTop;
        }) : [], o);
      },
          f = function f(t) {
        var e = t.element,
            n = t.item,
            r = c.getState(e),
            i = u.getConfig(e);
        if (r.isAnimating) return r;
        r.isAnimating = !0, n.appendChild(r._preview.cloneNode(!0));
        var o = n.querySelector(".Xpandy-wrapper"),
            a = n.querySelector(".Xpandy-body"),
            f = n.querySelector(".Xpandy-base"),
            p = n.querySelector(".Xpandy-content");
        i.arrow && setTimeout(function () {
          var t = n.querySelector(".Xpandy-arrow"),
              e = n.getBoundingClientRect();
          t.classList.add("Xpandy-arrow--isActive");
          var r = e.left + e.width / 2;
          t.style.left = r + "px";
        }, 125), o.addEventListener("transitionend", function t() {
          r.container.classList.add("Xpandy--isExpanded"), r.isAnimating = !1, o.removeEventListener("transitionend", t, !1);
        }, !1), f.innerHTML = p.innerHTML;
        var l = a.getBoundingClientRect().height,
            d = l + n.clientHeight;
        return n.style.height = n.clientHeight + "px", setTimeout(function () {
          return o.style.height = l + "px";
        }, 0), setTimeout(function () {
          return n.style.height = d + "px";
        }, 0), o.classList.add("Xpandy-preview--isOpening"), n.classList.add("Xpandy-item--isActive"), r._previewElements.push({
          preview: o,
          parentItem: n
        }), Array.from(o.querySelectorAll(".Xpandy-close")).forEach(function (t) {
          return t.addEventListener("click", function () {
            return s({
              element: e
            });
          });
        }), r.activeItems.push(n), i.callbacks.onOpen(n, r), r;
      },
          p = function p(t) {
        var e = t.element,
            n = t.item,
            r = t.itemOnSameRow,
            i = c.getState(e),
            o = u.getConfig(e);
        if (i.isAnimating) return i;
        i.isAnimating = !0;

        var a = n.querySelector(".Xpandy-content"),
            s = i._previewElements.find(function (t) {
          return t.parentItem.offsetTop === n.offsetTop;
        }),
            f = s.preview.querySelector(".Xpandy-body"),
            p = s.preview.querySelector(".Xpandy-base");

        i.activeItems = i.activeItems.filter(function (t) {
          return t !== r;
        }), i.activeItems.push(n), s.preview.classList.remove("Xpandy-preview--isOpening"), s.preview.classList.remove("Xpandy-preview--isUpdating"), setTimeout(function () {
          return s.preview.classList.add("Xpandy-preview--isUpdating");
        }, 0), n.classList.add("Xpandy-item--isActive"), r.classList.remove("Xpandy-item--isActive"), p.innerHTML = a.innerHTML;
        var l = n.querySelector(".Xpandy-thumbnail"),
            d = parseInt(getComputedStyle(l)["margin-top"]) + parseInt(getComputedStyle(l)["margin-bottom"]),
            v = f.getBoundingClientRect().height,
            y = v + l.clientHeight + d;

        if (s.preview.style.height = v + "px", s.parentItem.style.height = y + "px", o.arrow) {
          var m = s.preview.querySelector(".Xpandy-arrow"),
              g = n.getBoundingClientRect(),
              h = g.left + g.width / 2;
          m.style.left = h + "px";
        }

        return i.isAnimating = !1, o.callbacks.onUpdate(n, i), i;
      },
          l = function l(t) {
        var e = [];
        t.state.items.map(function (t) {
          t.style.height = "", t.querySelector(".Xpandy-thumbnail").style.height = "", e[t.offsetTop] || (e[t.offsetTop] = []), e[t.offsetTop].push(t.querySelector(".Xpandy-thumbnail"));
        }), Object.keys(e).map(function (t) {
          var n = e[t].reduce(function (t, e) {
            var n = e.getBoundingClientRect().height;
            return n > t ? n : t;
          }, 0);
          return e[t].map(function (t) {
            return "none" != t.style.display && 0 != n && (t.style.height = n + "px");
          });
        });
      };

      return Array.from(n).map(function (t) {
        if (c.stateExists(t)) return c.getState(t);
        var e = u.register(t),
            n = c.register(t);
        n.items = e.items ? Array.from(t.querySelectorAll(e.items)) : Array.from(t.children), n._preview = document.createRange().createContextualFragment(e.previewTemplate(e)), t.classList.add("Xpandy--isActive"), n.items.forEach(function (e) {
          e.querySelector(".Xpandy-thumbnail").addEventListener("click", function () {
            return a({
              element: t,
              item: e
            });
          });
        });
        var r = window.outerWidth;
        return window.addEventListener("resize", (0, o.debounce)(function () {
          if (e.equalHeights && l({
            state: n
          }), r !== window.outerWidth) return r = window.outerWidth, s({
            element: t
          });
        }, 250)), n.togglePreview = function (e) {
          e || s({
            element: t
          });
          var n = "string" == typeof e ? document.querySelector(e) : e;
          return a({
            element: t,
            item: n
          });
        }, e.equalHeights && l({
          state: n
        }), e.callbacks.onInit(), n;
      });
    }, t.exports = e["default"];
  }, function (t, e, n) {
    var r = n(0)("unscopables"),
        i = Array.prototype;
    void 0 == i[r] && n(3)(i, r, {}), t.exports = function (t) {
      i[r][t] = !0;
    };
  }, function (t, e, n) {
    var r = n(10).f,
        i = n(6),
        o = n(0)("toStringTag");

    t.exports = function (t, e, n) {
      t && !i(t = n ? t : t.prototype, o) && r(t, o, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e, n) {
    var r = n(1),
        i = n(2),
        o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
    (t.exports = function (t, e) {
      return o[t] || (o[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: r.version,
      mode: n(35) ? "pure" : "global",
      copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, e, n) {
    var r = n(31),
        i = n(12),
        o = n(59);

    t.exports = function (t) {
      return function (e, n, u) {
        var c,
            a = r(e),
            s = i(a.length),
            f = o(u, s);

        if (t && n != n) {
          for (; s > f;) {
            if ((c = a[f++]) != c) return !0;
          }
        } else for (; s > f; f++) {
          if ((t || f in a) && a[f] === n) return t || f || 0;
        }

        return !t && -1;
      };
    };
  }, function (t, e, n) {
    var r = n(14),
        i = n(20);

    t.exports = function (t) {
      return r(i(t));
    };
  }, function (t, e, n) {
    var r = n(60),
        i = n(28);

    t.exports = Object.keys || function (t) {
      return r(t, i);
    };
  }, function (t, e, n) {
    var r = n(2),
        i = n(3),
        o = n(6),
        u = n(17)("src"),
        c = Function.toString,
        a = ("" + c).split("toString");
    n(1).inspectSource = function (t) {
      return c.call(t);
    }, (t.exports = function (t, e, n, c) {
      var s = "function" == typeof n;
      s && (o(n, "name") || i(n, "name", e)), t[e] !== n && (s && (o(n, u) || i(n, u, t[e] ? "" + t[e] : a.join(String(e)))), t === r ? t[e] = n : c ? t[e] ? t[e] = n : i(t, e, n) : (delete t[e], i(t, e, n)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[u] || c.call(this);
    });
  }, function (t, e, n) {
    var r = n(8),
        i = n(2).document,
        o = r(i) && r(i.createElement);

    t.exports = function (t) {
      return o ? i.createElement(t) : {};
    };
  }, function (t, e) {
    t.exports = !1;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e["default"] = function () {
      [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function (t) {
        t.hasOwnProperty("remove") || Object.defineProperty(t, "remove", {
          configurable: !0,
          enumerable: !0,
          writable: !0,
          value: function value() {
            this.parentNode.removeChild(this);
          }
        });
      });
    }, t.exports = e["default"];
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e, n) {
    "use strict";

    var r = n(32),
        i = n(38),
        o = n(37),
        u = n(5),
        c = n(14),
        a = Object.assign;
    t.exports = !a || n(19)(function () {
      var t = {},
          e = {},
          n = Symbol(),
          r = "abcdefghijklmnopqrst";
      return t[n] = 7, r.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != a({}, t)[n] || Object.keys(a({}, e)).join("") != r;
    }) ? function (t, e) {
      for (var n = u(t), a = arguments.length, s = 1, f = i.f, p = o.f; a > s;) {
        for (var l, d = c(arguments[s++]), v = f ? r(d).concat(f(d)) : r(d), y = v.length, m = 0; y > m;) {
          p.call(d, l = v[m++]) && (n[l] = d[l]);
        }
      }

      return n;
    } : a;
  }, function (t, e, n) {
    var r = n(4);
    r(r.S + r.F, "Object", {
      assign: n(39)
    });
  }, function (t, e, n) {
    n(40), t.exports = n(1).Object.assign;
  }, function (t, e, n) {
    "use strict";

    var r = n(4),
        i = n(30)(!0);
    r(r.P, "Array", {
      includes: function includes(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(26)("includes");
  }, function (t, e, n) {
    n(42), t.exports = n(1).Array.includes;
  }, function (t, e, n) {
    var r = n(13);

    t.exports = Array.isArray || function (t) {
      return "Array" == r(t);
    };
  }, function (t, e, n) {
    var r = n(8),
        i = n(44),
        o = n(0)("species");

    t.exports = function (t) {
      var e;
      return i(t) && ("function" != typeof (e = t.constructor) || e !== Array && !i(e.prototype) || (e = void 0), r(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e;
    };
  }, function (t, e, n) {
    var r = n(45);

    t.exports = function (t, e) {
      return new (r(t))(e);
    };
  }, function (t, e, n) {
    var r = n(16),
        i = n(14),
        o = n(5),
        u = n(12),
        c = n(46);

    t.exports = function (t, e) {
      var n = 1 == t,
          a = 2 == t,
          s = 3 == t,
          f = 4 == t,
          p = 6 == t,
          l = 5 == t || p,
          d = e || c;
      return function (e, c, v) {
        for (var y, m, g = o(e), h = i(g), w = r(c, v, 3), x = u(h.length), b = 0, O = n ? d(e, x) : a ? d(e, 0) : void 0; x > b; b++) {
          if ((l || b in h) && (m = w(y = h[b], b, g), t)) if (n) O[b] = m;else if (m) switch (t) {
            case 3:
              return !0;

            case 5:
              return y;

            case 6:
              return b;

            case 2:
              O.push(y);
          } else if (f) return !1;
        }

        return p ? -1 : s || f ? f : O;
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(4),
        i = n(47)(5),
        o = !0;
    "find" in [] && Array(1).find(function () {
      o = !1;
    }), r(r.P + r.F * o, "Array", {
      find: function find(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(26)("find");
  }, function (t, e, n) {
    n(48), t.exports = n(1).Array.find;
  }, function (t, e, n) {
    var r = n(0)("iterator"),
        i = !1;

    try {
      var o = [7][r]();
      o["return"] = function () {
        i = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}

    t.exports = function (t, e) {
      if (!e && !i) return !1;
      var n = !1;

      try {
        var o = [7],
            u = o[r]();
        u.next = function () {
          return {
            done: n = !0
          };
        }, o[r] = function () {
          return u;
        }, t(o);
      } catch (t) {}

      return n;
    };
  }, function (t, e, n) {
    var r = n(13),
        i = n(0)("toStringTag"),
        o = "Arguments" == r(function () {
      return arguments;
    }());

    t.exports = function (t) {
      var e, n, u;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      }(e = Object(t), i)) ? n : o ? r(e) : "Object" == (u = r(e)) && "function" == typeof e.callee ? "Arguments" : u;
    };
  }, function (t, e, n) {
    var r = n(51),
        i = n(0)("iterator"),
        o = n(15);

    t.exports = n(1).getIteratorMethod = function (t) {
      if (void 0 != t) return t[i] || t["@@iterator"] || o[r(t)];
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(10),
        i = n(18);

    t.exports = function (t, e, n) {
      e in t ? r.f(t, e, i(0, n)) : t[e] = n;
    };
  }, function (t, e, n) {
    var r = n(15),
        i = n(0)("iterator"),
        o = Array.prototype;

    t.exports = function (t) {
      return void 0 !== t && (r.Array === t || o[i] === t);
    };
  }, function (t, e, n) {
    var r = n(9);

    t.exports = function (t, e, n, i) {
      try {
        return i ? e(r(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t["return"];
        throw void 0 !== o && r(o.call(t)), e;
      }
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(16),
        i = n(4),
        o = n(5),
        u = n(55),
        c = n(54),
        a = n(12),
        s = n(53),
        f = n(52);
    i(i.S + i.F * !n(50)(function (t) {
      Array.from(t);
    }), "Array", {
      from: function from(t) {
        var e,
            n,
            i,
            p,
            l = o(t),
            d = "function" == typeof this ? this : Array,
            v = arguments.length,
            y = v > 1 ? arguments[1] : void 0,
            m = void 0 !== y,
            g = 0,
            h = f(l);
        if (m && (y = r(y, v > 2 ? arguments[2] : void 0, 2)), void 0 == h || d == Array && c(h)) for (n = new d(e = a(l.length)); e > g; g++) {
          s(n, g, m ? y(l[g], g) : l[g]);
        } else for (p = h.call(l), n = new d(); !(i = p.next()).done; g++) {
          s(n, g, m ? u(p, y, [i.value, g], !0) : i.value);
        }
        return n.length = g, n;
      }
    });
  }, function (t, e, n) {
    var r = n(6),
        i = n(5),
        o = n(11)("IE_PROTO"),
        u = Object.prototype;

    t.exports = Object.getPrototypeOf || function (t) {
      return t = i(t), r(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
    };
  }, function (t, e, n) {
    var r = n(2).document;
    t.exports = r && r.documentElement;
  }, function (t, e, n) {
    var r = n(21),
        i = Math.max,
        o = Math.min;

    t.exports = function (t, e) {
      return (t = r(t)) < 0 ? i(t + e, 0) : o(t, e);
    };
  }, function (t, e, n) {
    var r = n(6),
        i = n(31),
        o = n(30)(!1),
        u = n(11)("IE_PROTO");

    t.exports = function (t, e) {
      var n,
          c = i(t),
          a = 0,
          s = [];

      for (n in c) {
        n != u && r(c, n) && s.push(n);
      }

      for (; e.length > a;) {
        r(c, n = e[a++]) && (~o(s, n) || s.push(n));
      }

      return s;
    };
  }, function (t, e, n) {
    var r = n(10),
        i = n(9),
        o = n(32);
    t.exports = n(7) ? Object.defineProperties : function (t, e) {
      i(t);

      for (var n, u = o(e), c = u.length, a = 0; c > a;) {
        r.f(t, n = u[a++], e[n]);
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(9),
        i = n(61),
        o = n(28),
        u = n(11)("IE_PROTO"),
        c = function c() {},
        _a = function a() {
      var t,
          e = n(34)("iframe"),
          r = o.length;

      for (e.style.display = "none", n(58).appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _a = t.F; r--;) {
        delete _a.prototype[o[r]];
      }

      return _a();
    };

    t.exports = Object.create || function (t, e) {
      var n;
      return null !== t ? (c.prototype = r(t), n = new c(), c.prototype = null, n[u] = t) : n = _a(), void 0 === e ? n : i(n, e);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(62),
        i = n(18),
        o = n(27),
        u = {};
    n(3)(u, n(0)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = r(u, {
        next: i(1, n)
      }), o(t, e + " Iterator");
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(8);

    t.exports = function (t, e) {
      if (!r(t)) return t;
      var n, i;
      if (e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
      if ("function" == typeof (n = t.valueOf) && !r(i = n.call(t))) return i;
      if (!e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e, n) {
    t.exports = !n(7) && !n(19)(function () {
      return 7 != Object.defineProperty(n(34)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(35),
        i = n(4),
        o = n(33),
        u = n(3),
        c = n(15),
        a = n(63),
        s = n(27),
        f = n(57),
        p = n(0)("iterator"),
        l = !([].keys && "next" in [].keys()),
        d = function d() {
      return this;
    };

    t.exports = function (t, e, n, v, y, m, g) {
      a(n, e, v);

      var h,
          w,
          x,
          b = function b(t) {
        if (!l && t in j) return j[t];

        switch (t) {
          case "keys":
          case "values":
            return function () {
              return new n(this, t);
            };
        }

        return function () {
          return new n(this, t);
        };
      },
          O = e + " Iterator",
          S = "values" == y,
          _ = !1,
          j = t.prototype,
          A = j[p] || j["@@iterator"] || y && j[y],
          X = A || b(y),
          E = y ? S ? b("entries") : X : void 0,
          T = "Array" == e && j.entries || A;

      if (T && (x = f(T.call(new t()))) !== Object.prototype && x.next && (s(x, O, !0), r || "function" == typeof x[p] || u(x, p, d)), S && A && "values" !== A.name && (_ = !0, X = function X() {
        return A.call(this);
      }), r && !g || !l && !_ && j[p] || u(j, p, X), c[e] = X, c[O] = d, y) if (h = {
        values: S ? X : b("values"),
        keys: m ? X : b("keys"),
        entries: E
      }, g) for (w in h) {
        w in j || o(j, w, h[w]);
      } else i(i.P + i.F * (l || _), e, h);
      return h;
    };
  }, function (t, e, n) {
    var r = n(21),
        i = n(20);

    t.exports = function (t) {
      return function (e, n) {
        var o,
            u,
            c = String(i(e)),
            a = r(n),
            s = c.length;
        return a < 0 || a >= s ? t ? "" : void 0 : (o = c.charCodeAt(a)) < 55296 || o > 56319 || a + 1 === s || (u = c.charCodeAt(a + 1)) < 56320 || u > 57343 ? t ? c.charAt(a) : o : t ? c.slice(a, a + 2) : u - 56320 + (o - 55296 << 10) + 65536;
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(68)(!0);
    n(67)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
          e = this._t,
          n = this._i;
      return n >= e.length ? {
        value: void 0,
        done: !0
      } : (t = r(e, n), this._i += t.length, {
        value: t,
        done: !1
      });
    });
  }, function (t, e, n) {
    n(69), n(56), t.exports = n(1).Array.from;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), n(70), n(49), n(43), n(41);
    var r = o(n(36)),
        i = o(n(25));

    function o(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }

    (0, r["default"])(), e["default"] = i["default"], t.exports = e["default"];
  }]);
});